module.exports = __webpack_public_path__ + "media/img/corporate/logos/kpmg-66c985d5304f7cfa1102055339d1b4c0.svg";